export const DONE_BUTTON_CLICKED = 'DONE_BUTTON_CLICKED';

export function closeModal(modalSelector, modalIsOpenCSSClass) {
    $(modalSelector).hide();
    // restore scrollable body
    $(document.body).removeClass(modalIsOpenCSSClass); // eslint-disable-line angular/document-service
}

export function closeFacetPanelModal(modalIsOpenCSSClass = 'has-modal-open') {
    closeModal('.js-facet-modal-panel', modalIsOpenCSSClass);
}

export function closeFacetsModal(modalIsOpenCSSClass = 'has-modal-open') {
    closeModal('.js-modal-facets', modalIsOpenCSSClass);
}

export function openModal(modalSelector, modalIsOpenCSSClass) {
    $(modalSelector).show();
    // disable scrollable body
    $(document.body).addClass(modalIsOpenCSSClass); // eslint-disable-line angular/document-service
}

export function openFacetPanelModal(modalIsOpenCSSClass = 'has-modal-open') {
    openModal('.js-facet-modal-panel', modalIsOpenCSSClass);
}

export function openFacetsModal(modalIsOpenCSSClass = 'has-modal-open') {
    openModal('.js-modal-facets', modalIsOpenCSSClass);
}

export function synchronizeWithMobileFacetState(mobileFacetState) {
    const showFacets = _.get(mobileFacetState, 'showFacets', false);

    if (showFacets) {
        openFacetsModal();
    } else {
        closeFacetsModal();
    }
}
